<template>
  <div class="bg-white rounded-lg shadow p-6">
    <h3 class="text-lg font-semibold text-gray-800">
      {{ title }}
      <span class="text-sm text-gray-500">{{ subtitle }}</span>
    </h3>
    <p class="text-sm text-gray-600 mt-2">
      {{ description }}
    </p>
    <div v-if="chartReady" class="mt-4">
      <apexchart
        type="line"
        height="400"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
    <div v-else class="text-gray-500 text-center py-8">
      Sin datos disponibles
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "QualityReportsLineChart",
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {};
  },
  props: {
    title: { required: true, type: String },
    subtitle: { type: String },
    description: { type: String },
    categories: { required: true, type: Array, default: () => [] },
    series: { required: true, type: Array, default: () => [] },
    yTitle: { type: String, default: "" },
    colors: { type: Array, default: () => [] },
    displayDataLabels: { type: Boolean, default: false },
    strokeCurve: { type: String, default: "straight" }
  },
  created() {},
  computed: {
    chartReady() {
      return this.series.length > 0;
    },

    chartOptions() {
      return {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false
          }
        },
        plotOptions: {
          line: {
            isSlopeChart: true
          }
        },
        tooltip: {
          followCursor: true,
          intersect: false,
          shared: true
        },
        dataLabels: {
          enabled: this.displayDataLabels,
          background: {
            enabled: true
          }
        },
        stroke: {
          curve: this.strokeCurve
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5
          }
        },
        xaxis: {
          categories: this.categories,
          position: 'bottom'
        },
        yaxis: {
          show: true,
          labels: {
            show: true
          },
          min: 0
        },
        colors: this.colors
      };
    }
  },
  methods: {},
  watch: {}
};
</script>
